
const DEFAULT_TITLE = 'Default Title'

function sanitizeOptionValue (text) {
  return text === DEFAULT_TITLE ? '' : text
}

export default sanitizeOptionValue
